import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Languages from '@/languages/languages.js'
import API from '@/plugins/api.js'
import ModalBus from '@/plugins/modal-bus.js'

Vue.use(API)
Vue.use(VueI18n)
Vue.use(ModalBus)

const i18n = new VueI18n({
  locale: 'hr',
  messages: Languages.translations,
})

export default function (error, store, router, prompt) {
  if (error.response.status !== 409) {
    return
  }

  if (store.state.user !== null) {
    i18n.locale = store.state.user.language
  }

  store.dispatch('setLoggedIn', false).then(() => {
    router.push({ name: 'Login' })

    prompt(
      i18n.t('helpers.handle_session_error.loggedOutPrompt.title'),
      i18n.t('helpers.handle_session_error.loggedOutPrompt.message'),
      result => {
        if (result === true) {
          return
        }

        Vue.prototype.$APICall(
          'post',
          'REPORT_WASNT_ME',
          '',
          {
            token: error.response.data.data.report_token,
          },
          () => {
            Vue.prototype.$alert(
              i18n.t('helpers.handle_session_error.loggedOutAlert.message')
            )
          },
          false
        )
      }
    )
  })
}
